import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgEducation(props: ISvgProps) {
	return (
		<svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#Education_svg__a)">
				<path
					d="m53.599 18.5-1.067.319-.465.139c-1.316.394-2.621.785-4.014 1.149v.061l-1.103.303c-3.699 1.013-7.416 2.106-11.174 3.21-1.151.339-2.306.678-3.466 1.017-.187.055-.355.112-.551.178-.15.051-.316.108-.52.173-.358.115-.907.282-1.415.297L53.6 18.5Zm0 0 .003-1.114M53.6 18.5l.003-1.114m0 0 .006-2.061.004-1.171-1.136-.288c-5.415-1.37-11.21-2.869-16.736-4.299l-2.642-.683-.003-.001c-.182-.047-.39-.108-.643-.182l-.084-.024a23.028 23.028 0 0 0-.914-.252 7.824 7.824 0 0 0-1.015-.191c-.33-.036-.767-.053-1.206.062h-.002c-3.418.897-6.91 1.77-10.426 2.649l-.073.018a925.944 925.944 0 0 0-10.607 2.695l-1.12.294v4.464l1.061.325c2.854.875 5.75 1.775 8.653 2.677 3.305 1.027 6.621 2.057 9.9 3.059m26.983-7.091L26.62 24.477m0 0c.223.068.437.148.694.244m-.694-.244.694.244m0 0c.19.071.403.15.662.241m-.662-.24.662.24m0 0c.457.16 1.186.404 1.848.384l-1.848-.384Z"
					stroke={props.primaryColor}
					strokeWidth={3}
				/>
				<path
					d="m47.236 20.2.04-.01v4.12l.341.115c.333.11.672.48.823.968.147.478.076.942-.226 1.251l-.572.585.782.242c.25.078.414.242.531.53.126.309.183.734.194 1.264.01.432-.011.895-.033 1.377l-.014.315c-.018.448-.033.91-.013 1.349-.544.176-1.199.266-1.874.263a6.81 6.81 0 0 1-1.916-.273c.019-.43.005-.883-.013-1.323l-.013-.304c-.021-.48-.042-.94-.032-1.37.013-.524.07-.944.195-1.248.116-.283.278-.443.526-.52l.73-.222-.496-.58c-.283-.332-.365-.87-.22-1.372.147-.506.468-.81.817-.85l.443-.051V20.2Z"
					fill={props.primaryColor}
					stroke={props.primaryColor}
				/>
				<path
					d="M43.782 22.445v-1.968L41.885 21c-2.892.795-5.736 1.655-8.559 2.51-1.235.373-2.467.746-3.696 1.111-4.19-1.372-8.411-2.712-12.63-4.046l-.326-.103-.339.048a1.557 1.557 0 0 0-1.31 1.234 1.736 1.736 0 0 0-.033.455c-.001 1.637 0 3.237 0 4.823.001 1.984.002 3.947 0 5.934l-.001.671.5.448c2.713 2.429 7.348 3.75 11.925 4.087 4.61.34 9.592-.287 13.144-2.17l.043-.023c.352-.187.975-.518 1.53-.884a6.27 6.27 0 0 0 .876-.678c.202-.194.672-.67.761-1.368l.012-.095V22.445Z"
					stroke={props.primaryColor}
					strokeWidth={3}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M29.94 59.914C20.59 55.522 11.135 51.24 1.724 46.91c-2.008-1.967-2.142-7.351-.458-9.799 4.181-1.945 8.365-3.886 12.592-5.785.053 1.119-.22 2.428 0 3.494.151.725 2.279 1.739 2.977 2.12 3.18 1.737 7.648 2.923 12.246 2.923 6.875 0 12.007-1.746 15.223-4.986v-1.416c2.111.847 4.71.415 6.367-.517v-3.509c2.766 1.49 6.09 3.036 8.854 4.525-10.133 5.002-20.35 9.916-30.502 14.897C20.284 45.21 11.62 41.49 2.928 37.8c-1.612 1.578-1.6 6.014-.228 7.849 8.339 3.794 26.59 12.315 26.897 12.317.352.003 1.36-.636 1.888-.915 9-4.757 18.232-9.491 27.239-14.207.22-.068.072-.502.115-.747.305.247.71.396.972.69.045.446-.087.715-.058 1.145L29.94 59.914Z"
					fill={props.secondaryColor}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M29.06 51.487 3.33 40.087l-.064-.478 25.728 11.4.065.478ZM29.269 53.91 3.54 42.51l-.067-.479 25.728 11.4.068.478ZM29.405 56.179 3.676 44.78l-.064-.48L29.34 55.7l.065.478Z"
					fill="#000"
				/>
			</g>
			<defs>
				<clipPath id="Education_svg__a">
					<path fill="#fff" transform="translate(0 7)" d="M0 0h60v53H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgEducation;
